import {
  StepperSidebar as CXStepperSidebar,
  Category as CXCategory,
  CATEGORY_STATE as CXCategoryState,
  SIDEBAR_COLOR as CXStepperColor,
  SIDEBAR_TYPE as CXSidebarType
} from '@sanlamcx/react-ui-next-stepper-new';

export type CATEGORY_STATE = CXCategoryState;
export const CATEGORY_STATE = CXCategoryState;
export const Category = CXCategory;
export const SIDEBAR_COLOR = CXStepperColor;
export const SIDEBAR_TYPE = CXSidebarType;
export const StepperSidebar = CXStepperSidebar;
